import copyDeck from "../../../joow-fak-copy.json"

type Localized = { fa: string; en: string }
type CopyDeck = typeof copyDeck
export type Locale = "fa" | "en"

export const copy = copyDeck as CopyDeck

export function fa(value: Localized): string {
  return value.fa
}

export function text(value: Localized, locale: Locale): string {
  return value[locale] || value.fa
}

export function format(value: Localized, vars: Record<string, string | number>): string {
  let out = value.fa
  for (const [key, replacement] of Object.entries(vars)) {
    out = out.replaceAll(`{${key}}`, String(replacement))
  }
  return out
}

export function formatLocalized(value: Localized, vars: Record<string, string | number>, locale: Locale): string {
  let out = text(value, locale)
  for (const [key, replacement] of Object.entries(vars)) {
    out = out.replaceAll(`{${key}}`, String(replacement))
  }
  return out
}

export function dirFor(locale: Locale): "rtl" | "ltr" {
  return locale === "fa" ? "rtl" : "ltr"
}
